module.exports = __webpack_public_path__ + "img/diamond-colored.a86de89b.svg";